import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";

import {
  AssociatedProductPayload,
  GroupedPp,
  ProjectPp,
  ProtectionProfile,
  PpAssociatedProduct,
} from "./protectionProfile.types";

const PROJECT_PPS_BASE_URL = "project/protection-profiles";
const PROTECTION_PROFILES_BASE_URL = "protection-profile";

const protectionProfilesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllProjectPp: build.query<ProjectPp[], number | string>({
      query: (ppId) => ({
        url: `${PROJECT_PPS_BASE_URL}/get_all_project_pp/`,
        params: {
          pp: ppId,
        },
      }),
      providesTags: ["ASSOCIATED_PRODUCTS"],
    }),

    getAllProjectPpByProductId: build.query<ProjectPp[], number | string>({
      query: (product_id) => ({
        url: `${PROJECT_PPS_BASE_URL}/get_all_projpp_by_product_id/`,
        params: {
          product_id,
        },
      }),
      // providesTags: ["ASSOCIATED_PRODUCTS"], // not sure if we need tags here...
    }),

    serializedProjectPp: build.query<PpAssociatedProduct[], number | string>({
      query: (product_id) => ({
        url: `${PROJECT_PPS_BASE_URL}/get_all_serialized_project_pp/`,
        params: {
          product: product_id,
        },
      }),
      transformResponse: (response: PpAssociatedProduct[]) => {
        return response.toSorted((a, b) => {
          return a.pp.pp_short_name.localeCompare(b.pp.pp_short_name);
        });
      },
    }),

    getNiapProtectionProfiles: build.query<ProtectionProfile[], void>({
      query: () =>
        `${PROTECTION_PROFILES_BASE_URL}/get_niap_protection_profiles/`,
    }),

    getProtectionProfile: build.query<ProtectionProfile, number | string>({
      query: (ppId) => `${PROTECTION_PROFILES_BASE_URL}/${ppId}`,
    }),

    associateProduct: build.mutation<
      PpAssociatedProduct[],
      AssociatedProductPayload
    >({
      query: (body) => ({
        url: `${PROJECT_PPS_BASE_URL}/set_association/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ASSOCIATED_PRODUCTS"],
    }),

    getGroupedPps: build.query<Record<number, GroupedPp[]>, void>({
      query: () => `${PROJECT_PPS_BASE_URL}/get_grouped_pp/`,
    }),

    ppDropdownOptions: build.query<Option[], void>({
      query: () => `${PROTECTION_PROFILES_BASE_URL}/get_pp_for_dropdown/`,
    }),

    pcmPpDropdownOptions: build.query<Option[], void>({
      query: () => ({
        url: `${PROTECTION_PROFILES_BASE_URL}/get_pp_for_dropdown/`,
        params: {
          is_pcm_pps: true,
        },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useAssociateProductMutation,
  useGetAllProjectPpQuery,
  useGetAllProjectPpByProductIdQuery,
  useGetNiapProtectionProfilesQuery,
  useLazyGetAllProjectPpByProductIdQuery,
  useGetProtectionProfileQuery,
  useGetGroupedPpsQuery,
  usePpDropdownOptionsQuery,
  usePcmPpDropdownOptionsQuery,
  useSerializedProjectPpQuery,
} = protectionProfilesApi;
